import { Environment } from '@thiememeulenhoff/types';
import { deployUrl } from './deploy-url';

export const environment = {
  environment: Environment.Production,
  production: true,
  deployUrl: deployUrl(),
  analytics: {
    tagManagerId: '',
    tagManagerAuth: '',
    tagManagerPreview: '',
  },
  thas: {
    environment: 'prod',
    token: '8ceb033cafb266dee4eda40f84e406d8ef9aebbdc0f7596510892388b8daacc3',
  },
  auth: {
    environment: Environment.Production,
    clientId: 'channels',
    clientSecret: '538bb4ef-ca0d-4623-8d08-fcfbd08dc932',
  },
};
